import { useState } from "react";

const ChooseDisbursementMethod = ({
  isChooseDisbursementMethodOpen,
  onSelectDisbursement,
  handleChooseBack,
  closeChooseDisbursementMethod,
}) => {
  const [selectedOption, setSelectedOption] = useState("");

  const handleSelection = (option) => {
    setSelectedOption(option);
  };

  const handleContinue = () => {
    if (selectedOption) {
      onSelectDisbursement(selectedOption);
    }
  };

  return (
    <>
      <div
        className={`${
          isChooseDisbursementMethodOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-10 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative bg-white shadow max-w-[50%] h-[36vh] mx-auto p-6 rounded-sm flex flex-col">
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-bold">Choose Disbursement Type</h2>
            <button
              onClick={closeChooseDisbursementMethod}
              className="text-xl font-bold"
            >
              ×
            </button>
          </div>
          <p className="text-gray-600 text-sm mt-2">
            Choose how the loan funds will be disbursed. You can select Bank
            Transfer or M-PESA as the recipient’s preferred method. Ensure all
            details are accurate before proceeding.
          </p>

          <div className="mt-6 flex-grow">
            <div className="flex items-center space-x-2">
              <input
                type="radio"
                id="mpesa"
                name="disbursement"
                value="M-PESA"
                checked={selectedOption === "M-PESA"}
                onChange={() => handleSelection("M-PESA")}
              />
              <label htmlFor="mpesa" className="text-black font-medium">
                M-PESA
              </label>
            </div>
            <div className="flex items-center space-x-2 mt-2">
              <input
                type="radio"
                id="bank"
                name="disbursement"
                value="BANK"
                checked={selectedOption === "BANK"}
                onChange={() => handleSelection("BANK")}
              />
              <label htmlFor="bank" className="text-black font-medium">
                BANK
              </label>
            </div>
          </div>

          {/* Buttons pinned at the bottom */}
          <div className="flex justify-between mt-auto">
            <button
              onClick={handleChooseBack}
              className="bg-[#7FB8EB] w-[243px] h-[51px] text-white px-4 py-2 rounded-md"
            >
              Back
            </button>
            <button
              className={`w-[243px] h-[51px] px-4 py-2 rounded-md ${
                selectedOption
                  ? "bg-[#074073] text-white"
                  : "bg-gray-400 text-white cursor-not-allowed"
              }`}
              disabled={!selectedOption}
              onClick={handleContinue}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChooseDisbursementMethod;
